/*
 *  -----------------------------------------------------------------------
 *    <copyright file="import-study-config.interface.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

export interface ImportStudyConfigProps {
    studyId: string;
    onClose: (data?: any) => void;
}

export enum StudyConfigImportExportStatus {
    NotApplicable,
    Success,
    Warning,
    Failure,
}

export enum StudyConfigImportExportAction {
    Insert,
    Update,
    Delete,
    Skip,
}

export enum StudyConfigurationImportType {
    Dashboards,
    DataTables,
    ExtraDataFields,
    Panels,
    Studies,
    SVTs,
    CRFs,
    Assessments,
    TreatmentArms,
    StudyVisit,
    Cohorts,
    DataFilters,
    DataViewConfiguration,
    Widgets,
    DashboardWidget,
    StudyHubSiteFieldsConfig,
    StudyHubStudyFieldsConfig,
    StudyDashboardConfig,
    StudyDashboardConfigPanel,
    SiteDataFilters,
    SubjectDataFilters,
    DataListingConfiguration,
    ControlsHubWidgets,
    ControlsHubConfigWidget,
    ControlsHubConfigPanel,
    DataListingsConfiguration,
    SubjectHubOverviewGridConfiguration,
    SubjectProfileDetailsConfiguration,
}

export type ISCDialogPages = 1 | 2 | 3 | 4;
